interface ShellRootProps {
  children: React.ReactNode;
  className?: string;
}

export const ShellRoot = ({ children, className = "" }: ShellRootProps) => {
  return <div className={className}>{children}</div>;
};
